module.exports = __webpack_public_path__ + "img/accompany.cd5fd4ec.svg";